import * as docketPropTypes from "../docketPropTypes";
import EnhancedCheckbox from "./EnhancedCheckbox";
import SimpleCheckbox from "./SimpleCheckbox";
import PropTypes from "prop-types";
import React, { PureComponent, Fragment } from "react";
import { Badge, Popover } from "antd";
import { StyleSheet, css } from "aphrodite/no-important";
import { InfoCircleOutlined } from "@ant-design/icons";
import * as colors from "../styles/colors";
import { blue } from "@ant-design/colors";

const checkboxStyleSheet = StyleSheet.create({
	checkboxInfoWrapper: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		gap: "8px",
		whiteSpace: "nowrap",
	},
	popupLink: {
		textDecoration: "underline",
		textDecorationColor: blue.primary,
	},
	popupText: {
		margin: "0",
		maxWidth: "200px",
	},
});

export default class Checkbox extends PureComponent {
	static propTypes = {
		aStyles: docketPropTypes.aphroditeStyles,
		aStylesIcon: docketPropTypes.aphroditeStyles,
		aStylesIconChecked: docketPropTypes.aphroditeStyles,
		aStylesIconContainer: docketPropTypes.aphroditeStyles,
		aStylesLabel: docketPropTypes.aphroditeStyles,
		checked: PropTypes.bool,
		disabled: PropTypes.bool,
		fullWidth: PropTypes.bool,
		label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
		onCheck: PropTypes.func,
		children: PropTypes.node,
		onDoubleClick: PropTypes.func,
		showCheckOnHover: PropTypes.bool,
		popup: PropTypes.shape({
			text: PropTypes.string,
			link: PropTypes.shape({
				url: PropTypes.string,
				text: PropTypes.string,
				targetIsBlank: PropTypes.bool,
			}),
		}),
		badge: PropTypes.string,
	};

	static defaultProps = {
		disabled: false,
		fullWidth: false,
		showCheckOnHover: false,
	};

	popupContent = (
		<div>
			{this.props.popup && this.props.popup.text ? (
				<p className={css(checkboxStyleSheet.popupText)}>{this.props.popup.text}</p>
			) : null}
			{this.props.popup && this.props.popup.link ? (
				<a
					href={this.props.popup.link.url}
					target={this.props.popup.link.targetIsBlank ? "_blank" : "_self"}
					className={css(checkboxStyleSheet.popupLink)}
				>
					{this.props.popup.link.text}
				</a>
			) : null}
		</div>
	);

	infoAndBadge = (
		<Fragment>
			{this.props.popup ? (
				<Popover
					placement="rightBottom"
					content={this.popupContent}
					arrow={false}
					trigger="hover"
				>
					<InfoCircleOutlined style={{ color: colors.graphGrey }} />
				</Popover>
			) : null}
			{this.props.badge ? (
				<Badge
					count={this.props.badge}
					style={{
						borderRadius: "4px",
						boxShadow: "none",
					}}
				/>
			) : null}
		</Fragment>
	);

	_renderEnhancedCheckbox = () => {
		return (
			<div className={css(checkboxStyleSheet.checkboxInfoWrapper)}>
				<EnhancedCheckbox
					aStyles={this.props.aStyles}
					aStylesIcon={this.props.aStylesIcon}
					aStylesIconChecked={this.props.aStylesIconChecked}
					aStylesIconContainer={this.props.aStylesIconContainer}
					aStylesLabel={this.props.aStylesLabel}
					checked={this.props.checked}
					disabled={this.props.disabled}
					fullWidth={this.props.fullWidth}
					label={this.props.label}
					onCheck={this.props.onCheck}
					onDoubleClick={this.props.onDoubleClick}
				>
					{this.props.children}
				</EnhancedCheckbox>
				{this.props.badge || this.props.popup ? this.infoAndBadge : null}
			</div>
		);
	};

	_renderSimpleCheckbox = () => {
		return (
			<div className={css(checkboxStyleSheet.checkboxInfoWrapper)}>
				<SimpleCheckbox
					aStyles={this.props.aStyles}
					aStylesIcon={this.props.aStylesIcon}
					aStylesIconChecked={this.props.aStylesIconChecked}
					aStylesIconContainer={this.props.aStylesIconContainer}
					aStylesLabel={this.props.aStylesLabel}
					checked={this.props.checked}
					disabled={this.props.disabled}
					fullWidth={this.props.fullWidth}
					label={this.props.label}
					onCheck={this.props.onCheck}
				/>
				{this.props.badge || this.props.popup ? this.infoAndBadge : null}
			</div>
		);
	};

	render() {
		return this.props.showCheckOnHover || this.props.onDoubleClick || this.props.children
			? this._renderEnhancedCheckbox()
			: this._renderSimpleCheckbox();
	}
}
